import { useEffect,  useState } from 'react';
import { MAX_TITLE_LENGTH } from '../../constants';

export default function NoteCreateModal({
  isNoteCreateModalOpen,
  setIsNoteCreateModalOpen,
  onSubmit,
}) {
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');
  const [tagsInput, setTagsInput] = useState('');

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setIsNoteCreateModalOpen(false);
      }
    };
    if (isNoteCreateModalOpen) {
      window.addEventListener('keydown', handleKeyDown);
    }
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isNoteCreateModalOpen, setIsNoteCreateModalOpen]);

  if (!isNoteCreateModalOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!title.trim()) {
      alert('タイトルを入力してください。');
      return;
    }

    const tags = tagsInput
      .split(/[,，、\s]+/)
      .map(t => t.replace(/^#/, '').trim())
      .filter(Boolean);

    onSubmit({
      title: title.trim(),
      body: body.trim(),
      summary: body.trim().split('\n')[0].slice(0, 100), // Simple fallback for summary
      tags,
    });

    setTitle('');
    setBody('');
    setTagsInput('');
  };

  return (
    <div className="fixed inset-0 z-[160] bg-black/60 flex items-center justify-center p-4 backdrop-blur-sm" onClick={(e) => { if (e.target === e.currentTarget) setIsNoteCreateModalOpen(false); }}>
      <div className="w-full max-w-xl bg-gray-900 border border-gray-800 rounded-2xl shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200">
        <form onSubmit={handleSubmit} className="flex flex-col max-h-[90vh]">
          {/* Header */}
          <div className="flex items-center justify-between p-4 border-b border-gray-800 bg-gray-900/50">
            <h2 className="text-lg font-bold text-white flex items-center gap-2">
              <span className="text-blue-500 text-xl">＋</span>
              メモを追加
            </h2>
            <button
              aria-label="閉じる"
              type="button"
              onClick={() => setIsNoteCreateModalOpen(false)}
              className="text-gray-500 hover:text-white transition-colors p-1"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Body */}
          <div className="p-4 space-y-4 overflow-y-auto">
            <div className="space-y-1.5">
              <label htmlFor="note-title" className="text-[10px] font-black uppercase tracking-widest text-gray-500 ml-1">Title (必須)</label>
              <input
                id="note-title"
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                maxLength={MAX_TITLE_LENGTH}
                className="w-full bg-gray-800 border border-gray-700 text-white p-3 rounded-xl text-sm focus:outline-none focus:border-blue-500 transition-all"
                placeholder="タイトルの入力..."
                autoFocus
              />
            </div>

            <div className="space-y-1.5">
              <label htmlFor="note-body" className="text-[10px] font-black uppercase tracking-widest text-gray-500 ml-1">Body (Markdown可)</label>
              <textarea
                id="note-body"
                value={body}
                onChange={(e) => setBody(e.target.value)}
                rows={8}
                className="w-full bg-gray-800 border border-gray-700 text-white p-3 rounded-xl text-sm focus:outline-none focus:border-blue-500 transition-all font-mono leading-relaxed"
                placeholder="内容を入力..."
              />
            </div>

            <div className="space-y-1.5">
              <label htmlFor="note-tags" className="text-[10px] font-black uppercase tracking-widest text-gray-500 ml-1">Tags (カンマ・スペース区切り)</label>
              <input
                id="note-tags"
                type="text"
                value={tagsInput}
                onChange={(e) => setTagsInput(e.target.value)}
                className="w-full bg-gray-800 border border-gray-700 text-white p-3 rounded-xl text-sm focus:outline-none focus:border-blue-500 transition-all"
                placeholder="例: 会議, アイデア, note"
              />
              <p className="text-[9px] text-gray-500 ml-1">#は自動で除去されます。</p>
            </div>
          </div>

          {/* Footer */}
          <div className="p-4 border-t border-gray-800 bg-gray-900/50 flex gap-3">
            <button
              type="button"
              onClick={() => setIsNoteCreateModalOpen(false)}
              className="flex-1 bg-gray-800 hover:bg-gray-700 text-gray-300 py-3 rounded-xl text-sm font-bold transition-all"
            >
              キャンセル
            </button>
            <button
              type="submit"
              className="flex-1 bg-blue-600 hover:bg-blue-500 text-white py-3 rounded-xl text-sm font-bold shadow-lg shadow-blue-900/20 transition-all active:scale-[0.98]"
            >
              作成
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
